'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dofIconfont = require('../dof-iconfont');

var _dofIconfont2 = _interopRequireDefault(_dofIconfont);

var _colmo = require('../../mixins/colmo');

var _colmo2 = _interopRequireDefault(_colmo);

var _diablo = require('../../mixins/diablo');

var _diablo2 = _interopRequireDefault(_diablo);

var _img = require('./img');

var _img2 = _interopRequireDefault(_img);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  mixins: [_colmo2.default, _diablo2.default],
  components: { DofIconfont: _dofIconfont2.default },
  props: {
    height: {
      type: Number,
      default: 40
    },
    color: {
      type: String,
      default: ''
    },
    vertical: {
      type: String,
      default: ''
    },
    max: {
      type: Number,
      default: 100
    },
    min: {
      type: Number,
      default: 0
    },
    step: {
      type: Number,
      default: 1
    },
    value: {
      type: Number,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  data: function data() {
    return {
      icons: _img2.default
    };
  },

  computed: {
    style: function style() {
      var res = { opacity: 1 };
      if (this.vertical) {
        switch (this.vertical) {
          case 'top':
            res.alignItems = 'flex-start';
            break;
          case 'middle':
            res.alignItems = 'center';
            break;
          case 'bottom':
            res.alignItems = 'flex-end';
        }
      }
      this.disabled && (res.opacity = 0.3);
      return res;
    },
    btnStyle: function btnStyle() {
      var res = {
        width: this.height + 'px',
        height: this.height + 'px',
        borderRadius: this.height / 2 + 'px',
        backgroundColor: this.color || (this._isDiablo ? '#2b2f32' : '#f2f2f2')
      };
      return res;
    }
  },
  methods: {
    onSubClick: function onSubClick() {
      if (this.disabled) return;
      var value = Math.max(this.value - this.step, this.min);
      this.$emit('change', value);
      this.$emit('sub');
    },
    onAddClick: function onAddClick() {
      if (this.disabled) return;
      var value = Math.min(this.value + this.step, this.max);
      this.$emit('change', value);
      this.$emit('add');
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-step-action/index.vue
// module id = 400
// module chunks = 0 1